module.exports = __webpack_public_path__ + "static/palmtrees-0acbfbdd0e6e132bcd48b52973fd3a3b.jpg";